module.exports = __webpack_public_path__ + "static/media/pause-button.dcbfc23a.svg";